import { render, staticRenderFns } from "./instructionName.vue?vue&type=template&id=3f443179"
import script from "./instructionName.vue?vue&type=script&lang=js"
export * from "./instructionName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports